<template>
  <div>
    <div style="height:calc(100vh - 120px);width:882px" ref="groupCategoryGrid"></div>
  </div>
</template>
<script>
import $ from '../../helpers/jquery-bridge'
import {enableExportExcel} from '../../helpers/export-helper'
import {mapGetters} from 'vuex'
import security from '@/mixins/security'
import {jsonDropDownEditor} from '@/helpers/kendo-editors'
import {kendoMultiSelect} from '../../helpers/kendo-editors'
import axios from 'axios'

export default {
  mixins: [security],
  mounted() {
    let vm = this

    let grid = $(this.$refs.groupCategoryGrid)
      .kendoGrid({
        dataSource: new kendo.data.DataSource({
          type: 'aspnetmvc-ajax',
          serverPaging: true,
          serverFiltering: true,
          serverSorting: true,
          pageSize: 15,
          transport: {
            create: {
              type: 'POST',
              url: '/api/config/groupCategory',
              data: () => ({clientId: this.clientId}),
              dataType: 'json',
            },
            read: {
              type: 'GET',
              url: '/api/config/groupCategory',
              data: () => ({clientId: this.clientId}),
              dataType: 'json',
            },
            update: {
              type: 'PUT',
              url: '/api/config/groupCategory',
              data: () => ({clientId: this.clientId}),
              dataType: 'json',
            },
            destroy: {
              type: 'DELETE',
              url: '/api/config/groupCategory',
            },
          },
          schema: {
            data: 'data',
            errors: 'errors',
            total: 'total',
            model: {
              id: 'groupCategoryId',
              fields: {
                groupCategoryId: {type: 'number', validation: {required: true}},
                groupCategoryName: {type: 'string', validation: {required: true}},
                groupCategoryTypeId: {
                  type: 'number',
                  validation: {required: true},
                  defaultValue: 1,
                },
                markets: {type: 'object', defaultValue: []},
                order: {type: 'number', defaultValue: -1},
                groupCategoryType: {type: 'string', validation: {required: true}},
                canDelete: {type: 'boolean', defaultValue: true, editable: false},
              },
            },
          },
          error: function() {
            grid.one('dataBinding', e => {
              e.preventDefault()
            })
          },
        }),
        dataBound: function(e) {
          let rows = e.sender.dataSource.data()
          rows.forEach(disableExpand)
        },
        cancel: function(e) {
          setTimeout(function() {
            disableExpand(e.model)
          }, 1)
        },
        toolbar: !vm.isReadOnly && vm.clientId > 0 ? ['create'] : [],
        editable: !vm.isReadOnly && 'inline',
        edit: function(e) {
          let groupCategoryTypeDropDownList = e.container
            .find('#groupCategoryType')
            .getKendoDropDownList()

          groupCategoryTypeDropDownList.enable(e.model.isNew())
        },
        filterable: true,
        sortable: true,
        pageable: true,
        columns: [
          {
            command: [{name: 'edit'}],
            width: 65,
            attributes: {style: 'text-align: center;'},
            hidden: vm.isReadOnly,
          },
          {
            title: 'Group Category',
            field: 'groupCategoryName',
            attributes: {style: 'text-align: left;'},
          },
          {
            title: 'Group Category Type',
            field: 'groupCategoryType',
            width: 182,
            headerAttributes: {style: 'text-align: center;'},
            attributes: {style: 'text-align: left;'},
            editor: jsonDropDownEditor(
              'groupCategoryTypeId',
              'groupCategoryType',
              '/api/config/groupCategory/getGroupCategoryType',
              {
                dataBound: function(e) {
                  e.sender.trigger('change')
                },
              },
              true,
            ),
          },
          {
            title: 'Markets',
            field: 'markets',
            width: 320,
            attributes: {class: 'truncate-grid-column-text'},
            filterable: false,
            sortable: false,
            template: dataItem => (dataItem.markets || []).map(el => el.market).join(', '),
            editor: kendoMultiSelect(
              'marketId',
              'market',
              '/api/config/groupCategory/getMarkets?clientId=' + this.clientId,
              {},
              true,
              false,
            ),
          },
          {
            command: [{name: 'destroy', visible: dataItem => dataItem.canDelete}],
            width: 65,
            attributes: {style: 'text-align: center;'},
            hidden: vm.isReadOnly,
          },
        ],
        detailInit: detailInit,
        detailCollapse: () => grid.dataSource.read(),
        detailExpand: container => container.masterRow.find('.k-grid-delete').hide(),
      })
      .getKendoGrid()
    enableExportExcel(grid, '/api/config/groupCategory/exportToExcel')

    grid.table.kendoSortable({
      filter: 'tr:not(tr[data-role=editable]):not(.k-detail-row)',
      hint: element => {
        let table = $('<table class="k-grid k-widget" ></table>')
        table.append(element.clone())
        table.css('opacity', 0.82)
        return table
      },
      cursor: 'ns-resize',
      placeholder: () => $('<tr class="k-dragged-placeholder"></tr>'),
      change: async e => {
        const sequenceGrid = grid,
          skip = sequenceGrid.dataSource.skip(),
          newIndex = e.newIndex + skip,
          selectedDataItem = sequenceGrid.dataSource.getByUid(e.item.data('uid'))

        sequenceGrid.dataSource.remove(selectedDataItem)
        sequenceGrid.dataSource.insert(newIndex, selectedDataItem)

        await axios.post('/api/config/groupCategory/updateSequence', {
          clientId: this.clientId,
          selectedId: selectedDataItem.groupCategoryId,
          newIndex: e.newIndex,
        })

        await sequenceGrid.dataSource.read()
      },
    })

    function disableExpand(dataItem) {
      let row = grid.table.find("tr[data-uid='" + dataItem.uid + "']")
      if (dataItem.groupCategoryTypeId != 1) {
        row.find('.k-icon.k-i-expand').hide()
      }
    }

    function detailInit(expandElement) {
      const groupCategoryId = expandElement.data.groupCategoryId
      let detailDataSource = new kendo.data.DataSource({
        type: 'aspnetmvc-ajax',
        serverPaging: true,
        serverSorting: true,
        serverFiltering: true,
        pageSize: 20,
        transport: {
          create: {
            type: 'POST',
            url: '/api/config/groupCategory/createDetail',
            dataType: 'json',
          },
          read: {
            type: 'GET',
            url: '/api/config/groupCategory/readDetail?groupCategoryId=' + groupCategoryId,
            dataType: 'json',
          },
          update: {
            type: 'PUT',
            url: '/api/config/groupCategory/updateDetail',
            dataType: 'json',
          },
          destroy: {
            type: 'DELETE',
            url: '/api/config/groupCategory/deleteDetail',
          },
        },
        schema: {
          data: 'data',
          errors: 'errors',
          total: 'total',
          model: {
            id: 'groupItemId',
            fields: {
              groupItemId: {type: 'number', defaultValue: 0},
              groupItemName: {type: 'string'},
              groupCategoryId: {type: 'number', editable: false, defaultValue: groupCategoryId},
              canDelete: {type: 'bool', defaultValue: true, editable: false},
            },
          },
        },
        error: function() {
          grid.one('dataBinding', e => {
            e.preventDefault()
          })
        },
      })

      $("<div style='width: 400px;' id='detail_" + groupCategoryId + "' class='k-content' />")
        .appendTo(expandElement.detailCell)
        .kendoGrid({
          dataSource: detailDataSource,
          scrollable: true,
          sortable: false,
          toolbar: !vm.isReadOnly && vm.clientId > 0 ? ['create'] : '',
          editable: !vm.isReadOnly && 'inline',
          pageable: true,
          columns: [
            {
              command: [{name: 'edit'}],
              width: 82,
              attributes: {style: 'text-align: center;'},
              hidden: vm.isReadOnly,
            },
            {
              title: 'Group Item',
              field: 'groupItemName',
              width: 100,
            },
            {
              command: [{name: 'destroy', visible: dataItem => dataItem.canDelete}],
              width: 82,
              attributes: {style: 'text-align: center;'},
              hidden: vm.isReadOnly,
            },
          ],
        })
    }
  },
  computed: {
    ...mapGetters({clientId: 'authentication/selectedClientId'}),
  },
}
</script>

<style>
.k-dragged-table {
  background-color: #f8f8f8;
}
.k-dragged-grid {
  height: calc(100vh - 90px - 82px - 32px);
}
.k-dragged-grid tbody tr {
  cursor: move;
}
.k-dragged-placeholder {
  outline-style: dashed !important;
  outline-width: 1px !important;
  outline-color: #ff6358 !important;
}
</style>
